import * as Joi from 'joi';
import { Column, Entity, OneToMany } from 'typeorm';
import { GenPartial } from 'typeormgen';
import InventorySatellite from '../inventory-satellites/inventory-satellite.entity';
import SetPiece from '../set-pieces/set-piece.entity';
import SetWrapBox from '../set-wrap-boxes/set-wrap-box.entity';

@Entity('set_storage_locations')
export default class SetStorageLocation extends InventorySatellite {
	static readonly tableName = 'set_storage_locations';
	@Column('varchar')
	mobile_id: string;

	@OneToMany((type) => SetPiece, (setPiece) => setPiece.storageLocation)
	setPieces: SetPiece[];

	@OneToMany(
		(type) => SetWrapBox,
		(setWrapBox) => setWrapBox.setStorageLocation
	)
	setWrapBoxes: SetWrapBox[];

	static rules() {
		return {
			...InventorySatellite.rules(),
			mobile_id: Joi.string().max(36).allow(null, ''),
		};
	}

	constructor(props?: GenPartial<SetStorageLocation>) {
		super(props);
	}
}
